import React from 'react';
import { Control, Controller, UseFormHandleSubmit } from 'react-hook-form';
import { Button, InputText, LogoIcon, TranslatedTextError } from 'src/components';
import { Screen } from 'src/components/Screen';
import { SText } from 'src/components/SText';
import { TrackingColiPublicDataFetchPayload } from '../../tracking-colis-public.types';

type Props = {
  testID?: string;
  error: Error | null;
  handleSubmit: UseFormHandleSubmit<TrackingColiPublicDataFetchPayload>;
  errors: any;
  control: Control<TrackingColiPublicDataFetchPayload, object>;
  onSubmit: ({ code, tracking }: TrackingColiPublicDataFetchPayload) => void;
};

export const TrackingColiPublicAuthFom: React.FC<Props> = ({
  handleSubmit,
  control,
  errors,
  testID = 'TrackingColiPublicAuthFom',
  onSubmit,
  error: serverError,
}) => {
  return (
    <div data-testid={testID} className="">
      <Screen className="bg-white flex-col" center>
        <LogoIcon className="w-40 md:w-64" />

        <form
          className=" w-full md:w-1/2  px-4 justify-center flex py-2 mt-1  md:mt-8 flex-col items-center"
          style={{ maxWidth: 450 }}
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <div>
            <SText
              classNames="block text-xl text-primary font-semibold text-center my-1"
              label="public.track-your-colis"
            />
            <SText
              classNames="block color-primary text-gray-500 my-2"
              label="public.enter-sending-code-and-shippping-id"
            />
          </div>
          <Controller
            name="tracking"
            control={control}
            render={({ field: { onBlur, onChange, value } }) => {
              return (
                <InputText
                  value={value}
                  showUpLabel
                  placeholder="public.tracking-code"
                  error={errors?.tracking}
                  onChange={onChange}
                  onBlur={onBlur}
                  type="text"
                />
              );
            }}
          />

          <Controller
            name="code"
            control={control}
            render={({ field: { onBlur, value, onChange } }) => {
              return (
                <InputText
                  showUpLabel
                  placeholder="public.code"
                  type="text"
                  value={value}
                  error={errors?.code}
                  onChange={onChange}
                  onBlur={onBlur}
                />
              );
            }}
          />

          <Button type="submit" label="global.cta-valid" extraClasses="w-full mt-6" />
          {!!serverError && <TranslatedTextError message={serverError?.message} />}
        </form>
      </Screen>
    </div>
  );
};
